import { inject } from '@angular/core';
import { Observable, switchMap, take } from 'rxjs';
import { ChatInitializer } from '../../../initializers';
import { ChatChannelType } from '@core-http';
import { CacheKey } from '@core';
import { Router } from '@angular/router';

export class OpenChatCommandHandler {
  private readonly chatInitializer: ChatInitializer = inject(ChatInitializer);
  private readonly router: Router = inject(Router);

  open(channelExternalId: string, channelType: ChatChannelType): Observable<void> {
    sessionStorage.setItem(CacheKey.RedirectToGameFromChatUrl, this.router.url);

    return this.chatInitializer.init().pipe(
      take(1),
      switchMap(() => this.chatInitializer.openChannel(channelExternalId, channelType))
    );
  }
}
